module.exports = __webpack_public_path__ + "img/circle-arrow-right-white.976eae31.svg";